import * as components from './components'

export default [
  {
    path: '/stream/:uuid/progress',
    component: components.StreamProgress,
    name: 'streamProgress',
    props: true
  },
  {
    path: '/stream/:uuid/career',
    component: components.StreamCareer,
    name: 'streamCareer',
    props: true
  },
  {
    path: '/stream/:uuid/time',
    component: components.StreamTime,
    name: 'streamTime',
    props: true
  },
  {
    path: '/stream/:uuid/category',
    component: components.StreamCategory,
    name: 'streamCategory',
    props: true
  },
  {
    path: '/stream/:uuid/planner',
    component: components.StreamPlanner,
    name: 'streamPlanner',
    props: true
  },
  {
    path: '/stream/:uuid/planStream',
    component: components.PlanStream,
    name: 'planStream',
    props: true
  },
  {
    path: '/stream/:uuid/report',
    component: components.StreamReport,
    name: 'streamReport',
    props: true
  },
  {
    path: '/stream/:uuid/report/user/:userId',
    component: components.StreamReport,
    name: 'userActivityReport',
    props: true
  },
  {
    path: '/stream/:uuid/programguide',
    component: components.ProgramGuide,
    name: 'programGuide',
    props: true
  },
  {
    path: '/stream/student/upload',
    component: components.StudentStreamUpload,
    name: 'studentStreamUpload',
    props: true
  },
  {
    path: '/stream/alumni/upload',
    component: components.AlumniStreamUpload,
    name: 'alumniStreamUpload',
    props: true
  },
  {
    path: '/stream/advisor/upload',
    component: components.AdvisorStreamUpload,
    name: 'advisorStreamUpload',
    props: true
  },
  {
    path: '/stream/courseOptions/upload',
    component: components.CourseOptionsUpload,
    name: 'courseOptionsUpload',
    props: true
  },
  {
    path: '/stream/aarRequirements/upload',
    component: components.AARRequirementsUpload,
    name: 'aarRequirementsUpload',
    props: true
  }

]



// WEBPACK FOOTER //
// ./src/app/stream/routes.js